var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingButton } from '@mui/lab';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGasSufficiency } from '../../hooks';
import { useWallet, useWidgetConfig } from '../../providers';
import { navigationRoutes } from '../../utils';
export const SwapButton = forwardRef(({ onClick, currentRoute, text, disable, enableLoading, loading }, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { variant, walletManagement } = useWidgetConfig();
    const { account, connect } = useWallet();
    const { insufficientFunds, insufficientGas, isLoading: isGasSufficiencyLoading, } = useGasSufficiency(currentRoute);
    const handleSwapButtonClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!account.isActive) {
            if (walletManagement) {
                yield connect();
            }
            else {
                navigate(navigationRoutes.selectWallet);
            }
        }
        else {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    });
    const getButtonText = () => {
        if (account.isActive) {
            if (!currentRoute) {
                return variant !== 'refuel' ? t(`button.swap`) : t(`button.getGas`);
            }
            if (text) {
                return text;
            }
            return variant !== 'refuel'
                ? t(`button.reviewSwap`)
                : t(`button.startGasSwap`);
        }
        return t(`button.connectWallet`);
    };
    return (_jsx(LoadingButton, Object.assign({ variant: "contained", color: "primary", onClick: handleSwapButtonClick, disabled: insufficientFunds || !!(insufficientGas === null || insufficientGas === void 0 ? void 0 : insufficientGas.length) || disable, loading: enableLoading && (loading || isGasSufficiencyLoading), loadingPosition: "center", fullWidth: true, ref: ref }, { children: getButtonText() })));
});
